import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase/supabaseClient";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // 이메일/비번 로그인
  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    const { error } = await supabase.auth.signInWithPassword({ email, password: pw });
    if (error) setError(error.message);
    else navigate("/");
  }

  // 구글 로그인
  async function handleGoogleLogin() {
  await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: "https://www.a-blind.com/board", // 로그인 완료 후 돌아올 주소
    },
  });
}
  

  return (
    <form className="max-w-sm mx-auto mt-20 bg-white p-8 shadow rounded" onSubmit={handleLogin}>
      <h2 className="text-2xl font-bold mb-4">로그인</h2>
      <input
        type="email"
        placeholder="이메일"
        className="border p-2 mb-2 w-full"
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="비밀번호"
        className="border p-2 mb-2 w-full"
        value={pw}
        onChange={e => setPw(e.target.value)}
      />
      {error && <div className="mb-2 text-red-500">{error}</div>}

      <button type="submit" className="w-full bg-black text-white py-2 rounded">
        로그인
      </button>
      <button type="button" onClick={handleGoogleLogin}
        className="w-full bg-gray-200 mt-3 py-2 rounded hover:bg-gray-300">
        Google로 로그인
      </button>

     <div className="mt-6 text-center">
      <span className="mr-2">비밀번호를 잊으셨나요?</span>
     <button
      type="button"
      onClick={() => navigate("/reset-password-request")}
      className="text-blue-600 font-bold underline"
     >
      비밀번호 재설정
     </button>
     </div>
      
      <div className="mt-6 text-center">
        <span className="mr-2">아직 회원이 아니신가요?</span>
        <button
          type="button"
          onClick={() => navigate("/signup")}
          className="text-blue-600 font-bold ml-1 underline"
        >
          가입하기
        </button>
      </div>

      
    </form>
  );
}
